<div
  class="animated fadeIn faster fixed inset-0 top-0 left-0 z-50 flex h-screen min-w-screen items-center justify-center bg-cover bg-center bg-no-repeat outline-none focus:outline-none"
  id="modal-id"
>
  <div class="absolute inset-0 z-0 bg-black opacity-30"></div>
  <div class="bg-lightGrayish relative m-auto w-full max-w-lg rounded-xl p-5 shadow-lg">
    <div class="flex flex-col items-center p-7 text-center" data-cy="confirm-dialog">
      @if (data.image) {
        <img class="h-8" src="assets/img/icons/{{ data.image }}.png" alt="delete" />
      }
      <h2 class="pb-4 text-xl">{{ data.headline }}</h2>
      <p class="text-slateGray px-8 text-sm">{{ data.text }}</p>
      @if (data.isRejectTraining) {
        <div class="mt-4 w-full px-6">
          <textarea
            [(ngModel)]="data.rejectionReason"
            class="h-20 w-full resize-none border border-gray-300 p-2 focus:ring-0 focus:outline-none"
            name="rejectTraining0"
            placeholder="Reason for rejection"
          ></textarea>
        </div>
      }

      <div class="mt-3 flex w-full items-center justify-between">
        <div class="mt-2 flex items-center space-x-4 text-center">
          <button
            (click)="onAccept()"
            class="bg-almostBlack text-sunflowerGold mb-2 flex h-9 items-center justify-center border border-black px-5 py-2.5 text-center text-sm font-medium tracking-wider shadow-sm hover:bg-black hover:shadow-lg focus:ring-4 focus:outline-none sm:w-auto md:mb-0"
            data-cy="modal-confirm-button"
          >
            {{ onAcceptButtonText }}
          </button>
        </div>
        <div class="mt-2 flex justify-center space-x-4 text-center">
          <button
            (click)="onClose()"
            class="text-slateGray mb-2 flex h-9 items-center border bg-white px-5 py-2 text-sm font-medium tracking-wider shadow-sm hover:bg-gray-100 hover:shadow-lg md:mb-0"
            data-cy="pi-reject-del-button"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
